/**
 * Created by sshu on 2018/12/19
 */
import * as API from './index';

// 用户登录
export const login = (params) => {
    params.logintype = 5;
    return API.POST('/base/baselogin/login', params);
};

// 获取用户详情
export const findUserInfo = (params) => {
    return API.GET('/userMgr/baselogin/getUserInfo', params);
};
// 获取用户信息(和登录返回信息一致包含Token)
export const findLoginUserInfo = (params) => {
    return API.GET('/userMgr/baselogin/getLoginUserInfo', params);
};
// 获取用户信息(和登录返回信息一致包含Token)
export const findUserInfoByToken = (params) => {
    return API.GET('/userMgr/baselogin/getUserInfoByToken', params);
};
// 修改用户密码
export const editUserPassWord = (params) => {
    return API.POST('/userMgr/baselogin/modifyPassWord', params);
};

// 获取代理商用户信息
export const findAgentInfoByUserId = (params) => {
    return API.GET('/userMgr/agent/getAgentInfoByUserId', params);
};

// 根据用户id，学校id，用户类型获取菜单列表
export const getMenuByUserInfo = (params) => {
    return API.GET('/userMgr/basemenu/getMenuByUser', params);
};

// 获取省市区
export const findAreaList = (params) => {
    return API.GET('/userMgr/baseregion/getRegion', params);
};

// 根据字典类别获取具体的条目
export const findDictList = (params) => {
    return API.GET('/appmgr/dict/getDictList', params);
};

// 获取学制列表
export const findSystemCodeList = (params) => {
    return API.GET('/userMgr/baseclass/getSystemCodeList', params);
};

// 获取年级
export const findGradeList = (params) => {
    return API.GET('/userMgr/basegrade/getGradeListBySchoolId', params);
};

// 根据学段获取年级
export const findGradeListByPhase = (params) => {
    return API.GET('/userMgr/basegrade/getGradeList', params);
};

// 验证文件md5
export const validateFileMd5 = (params) => {
    return API.GET('/resource/resource/validatemd5', params);
};

// 添加教师
export const addTea = (params) => {
    return API.POST('/userMgr/baselogin/addTeacher', params);
};

// 获取用户的应用和菜单
export const findMenuByUser = (params) => {
    return API.GET('/appmgr/roleAppMeun/getAppMenuByUser', params);
};
// 公共导出——发送导出消息
export const commonExportDataRecord = (params) => {
    return API.POST('/public/export/commonExportRecord', params);
};
// 根据字典类别获取具体的条目——公共字典
export const findBaseDictList = (params) => {
    return API.GET('/userMgr/basedict/getDictList', params);
};
// 获取用户角色
export const findUserRoleIdList = (params) => {
    return API.GET('/operag/operator/getUserRoleIdList', params);
};
// 根据学校id查找学校信息
export const findSchoolById = (params) => {
    return API.GET('/userMgr/baseschool/getSchoolById', params)
};
// 根据code获取用户信息
export const findUserInfoByCode = (params) => {
    return API.GET('/userMgr/tencent/getUserInfoByCode', params)
};
// 通过第三方用户id获取同步用户信息
export const findLoginUserInfoByThirdId = (params) => {
    return API.GET('/userMgr/tencent/getLoginUserInfoByThirdId', params)
};
// 验证文件md5——公共资源
export const validatePublicFileMd5 = (params) => {
    return API.GET('/resource/public/validateMd5', params);
};
// 根据用户id获取区域管理员的信息
export const getPlatFormInfoByUserIdAPI = (params) => {
    return API.GET('/platformManage/getPlatFormInfoByUserId', params);
};
//获取公共缓存集合
export const getCommonCatchListByAppTypes = (params) => {
    return API.GET('/public/catch/getCommonCatchListByAppTypes', params);
};
//获取Authorization
export const loginByTokenAPI = (params) => {
    return API.GET('/user/portal/loginByToken', params, process.env.VUE_APP_STUDYCOURSE_URL);
};
// 第一步获取安全码
export const findSafeCode = (params) => {
    return API.GET('/base/register/getsafetyid', params);
}
// 第二步获取短信验证码
export const findSMSCodeByMobile = (params) => {
    return API.GET('/userMgr/register/getNewSMSCodeByMobile', params);
}
/**
 * @name: 获取腾讯验证码应用id
 */
export const findAppId = (params = {}) => {
    return API.POST("/userMgr/verificationCode/getAppId", params);
};
/**
 * @name: 【注册】[第三步]校验短信验证码
 */
export const checkMobileCodeAPI = (params = {}) => {
    return API.POST("/userMgr/register/checkMobileCode", params);
};
/**
 * @name 【注册】[第四步]登录
 **/
export const loginByMobileCodeAPI = (params = {}) => {
    return API.POST("/base/baselogin/loginByMobileCode", params);
};